import React from "react";

const TotalJobs = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="54"
      height="54"
      viewBox="0 0 54 54"
      fill="none"
    >
      <rect width="54" height="54" rx="8" fill="#DEFDFF" />
      <path
        d="M19 37V35H21V32C21 30.9833 21.2375 30.0292 21.7125 29.1375C22.1875 28.2458 22.85 27.5333 23.7 27C22.85 26.4667 22.1875 25.7542 21.7125 24.8625C21.2375 23.9708 21 23.0167 21 22V19H19V17H35V19H33V22C33 23.0167 32.7625 23.9708 32.2875 24.8625C31.8125 25.7542 31.15 26.4667 30.3 27C31.15 27.5333 31.8125 28.2458 32.2875 29.1375C32.7625 30.0292 33 30.9833 33 32V35H35V37H19Z"
        fill="#51D3DB"
      />
    </svg>
  );
};

export default TotalJobs;
